import apiV2 from "api-v2";

interface QuoteCommentRequest {
	inviteId: number;
	quoteId: number;
}

interface QuoteCommentResponse {
	comment: string;
	revision: number;
}

interface SaveQuoteCommentPayload {
	comment: string;
}

export const getQuoteComment = async (
	request: QuoteCommentRequest
): Promise<QuoteCommentResponse | null> => {
	const response = await apiV2.get<{ data: QuoteCommentResponse | null }>(
		`rfx-invite/${request.inviteId}/quotes/${request.quoteId}/comment`
	);
	return response.data.data;
};

export const saveQuoteComment = async (
	request: QuoteCommentRequest,
	payload: SaveQuoteCommentPayload
): Promise<QuoteCommentResponse> => {
	const response = await apiV2.post<{ data: QuoteCommentResponse }>(
		`rfx-invite/${request.inviteId}/quotes/${request.quoteId}/comment`,
		payload
	);
	return response.data.data;
};
